// Builders for basic-search (dtSearch) query strings.

/** `field CONTAINS "value"` */
export function fieldContains(field: string, value: string): string {
  return `${field} CONTAINS "${value}"`;
}

/** `field CONTAINS yyyy-mm-dd TO yyyy-mm-dd`, using local calendar dates. */
export function dateRangeContains(field: string, start: Date, end: Date): string {
  return `${field} CONTAINS ${formatSearchDate(start)} TO ${formatSearchDate(end)}`;
}

export function formatSearchDate(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
